export default class PlaceCard extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-place-card', PlaceCard);
